<template>
  <b-modal
    @ok="createNewAllocationUnit"
    @cancel="closeDialog"
    @show="resetForm"
    id="newAllocationUnitModal"
    title="Neue Vergabeeinheit erstellen"
  >
    <b-form-group id="input-group-ordinal" label="ID" label-for="input-ordinal" class="">
      <b-form-input
        v-model="allocationUnit.Ordinal"
        id="input-ordinal"
        type="text"
        placeholder="ID"
        required
        autofocus
      ></b-form-input>
    </b-form-group>
    <b-form-group
      id="input-group-newAllocationUnit-1"
      label="Bezeichnung"
      label-for="input-NewAllocationUnit-displayName"
      class=""
    >
      <b-form-input
        v-model="allocationUnit.DisplayName"
        id="input-NewAllocationUnit-displayName"
        type="text"
        placeholder="Bezeichnung"
        required
      ></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
import allocationUnitsService from '@/service/AllocationUnitsService.js';
import projectStore from '@/store/Projects';
export default {
  data() {
    return {
      allocationUnit: {
        Ordinal: '',
        DisplayName: ''
      }
    };
  },
  emits: ['success', 'error'],
  methods: {
    createNewAllocationUnit() {
      allocationUnitsService.createNewAllocationUnit(projectStore.activeProject.DbId, this.allocationUnit, err => {
        if (err) this.$emit('error', err);
        else this.$emit('success', null);
      });
    },
    closeDialog() {},
    resetForm() {
      this.allocationUnit = {};
      this.Ordinal = '';
      this.DisplayName = '';
    }
  }
};
</script>

<style></style>
